import BumiLuhur1 from '../Bumi Luhur/Bumi Luhur (1).webp'
import BumiLuhur2 from '../Bumi Luhur/Bumi Luhur (2).webp'
import BumiLuhur3 from '../Bumi Luhur/Bumi Luhur (3).webp'
import BumiLuhur4 from '../Bumi Luhur/Bumi Luhur (4).webp'
import BumiLuhur5 from '../Bumi Luhur/Bumi Luhur (5).webp'
import BumiLuhur6 from '../Bumi Luhur/Bumi Luhur (6).webp'
import BumiLuhur7 from '../Bumi Luhur/Bumi Luhur (7).webp'

const BumiLuhurimages =[
BumiLuhur1,BumiLuhur2,BumiLuhur3,BumiLuhur4,BumiLuhur5,BumiLuhur6,BumiLuhur7
]

export default BumiLuhurimages;